import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const OnboardingComplete = () => {
  const [searchParams] = useSearchParams();
  const [redirectAttempted, setRedirectAttempted] = useState(false);
  const [showManualRedirect, setShowManualRedirect] = useState(false);
  const cleanerId = searchParams.get("cleanerId");

  // Create the deep link URL
  const deepLink = cleanerId 
    ? `com.flavoursoft.freshsweeperv5://onboarding-complete?cleanerId=${cleanerId}`
    : `com.flavoursoft.freshsweeperv5://onboarding-complete`;

  useEffect(() => {
    // Don't redirect immediately when coming from Stripe
    // Instead, show a button or countdown
    const timer = setTimeout(() => {
      setShowManualRedirect(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const redirectToApp = () => {
    console.log('🔗 Redirecting to app:', deepLink);
    setRedirectAttempted(true);
    
    // Try multiple methods for better compatibility
    const methods = [
      () => { window.location.href = deepLink; },
      () => { window.location.replace(deepLink); },
      () => { 
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = deepLink;
        document.body.appendChild(iframe);
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }
    ];
    
    // Try each method
    methods.forEach(method => {
      try {
        method();
      } catch (e) {
        console.log('Redirect method failed:', e);
      }
    });

    // Fallback to web after delay
    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        console.log('📱 App not installed, staying on web');
        // Optionally redirect to web dashboard
        // window.location.href = `/dashboard?cleanerId=${cleanerId}`;
      }
    }, 2000);
  };

  return (
    <div style={styles.container}>
      <h2>🎉 Onboarding Complete!</h2>
      
      {cleanerId && (
        <div style={styles.infoBox}>
          <p><strong>Cleaner ID:</strong> {cleanerId}</p>
        </div>
      )}

      {!showManualRedirect ? (
        <p>Processing your Stripe onboarding completion...</p>
      ) : (
        <>
          <p>Your Stripe account setup is complete!</p>
          
          <div style={styles.buttonContainer}>
            <button 
              onClick={redirectToApp}
              style={styles.primaryButton}
            >
              Open FreshSweeper App
            </button>
            
            <p style={styles.note}>
              If the app doesn't open automatically, tap the button above.
            </p>
            
            <div style={styles.alternativeButtons}>
              <a href={`/dashboard?cleanerId=${cleanerId}`} style={styles.secondaryButton}>
                Continue on Web
              </a>
              <a href="/" style={styles.tertiaryButton}>
                Go to Homepage
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '40px 20px',
    textAlign: 'center',
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    maxWidth: '600px',
    margin: '0 auto',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoBox: {
    background: '#f8f9fa',
    padding: '15px',
    borderRadius: '8px',
    margin: '20px 0',
    border: '1px solid #e9ecef',
  },
  fallback: {
    marginTop: '30px',
    padding: '20px',
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(36, 48, 63, 0.08)',
    border: '1px solid #e0e0e0',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    margin: '20px 0',
  },
  primaryButton: {
    display: 'inline-block',
    padding: '12px 24px',
    backgroundColor: '#00BFFF',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '16px',
    transition: 'background-color 0.2s',
  },
  secondaryButton: {
    display: 'inline-block',
    padding: '12px 24px',
    backgroundColor: '#6c757d',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '16px',
    transition: 'background-color 0.2s',
  },
};

export default OnboardingComplete;


// import React, { useEffect, useState, useRef } from 'react';
// import { useSearchParams } from 'react-router-dom';

// const OnboardingComplete = () => {
//   const [searchParams] = useSearchParams();
//   const [redirectAttempted, setRedirectAttempted] = useState(false);
//   const [showFallback, setShowFallback] = useState(false);
//   const [countdown, setCountdown] = useState(3);
//   const cleanerId = searchParams.get("cleanerId");
  
//   const redirectAttemptedRef = useRef(false);
//   const fallbackTimerRef = useRef(null);

//   // Create the deep link URL
//   const deepLink = cleanerId 
//     ? `freshsweeper://onboarding-complete?cleanerId=${cleanerId}`
//     : `freshsweeper://onboarding-complete`;

//   const attemptRedirect = (method) => {
//     if (redirectAttemptedRef.current) return;
    
//     console.log(`🔄 Attempting redirect with method: ${method}`);
    
//     try {
//       switch(method) {
//         case 'location_href':
//           window.location.href = deepLink;
//           break;
          
//         case 'location_replace':
//           window.location.replace(deepLink);
//           break;
          
//         case 'iframe':
//           const iframe = document.createElement('iframe');
//           iframe.style.display = 'none';
//           iframe.src = deepLink;
//           document.body.appendChild(iframe);
//           setTimeout(() => {
//             if (document.body.contains(iframe)) {
//               document.body.removeChild(iframe);
//             }
//           }, 1000);
//           break;
          
//         case 'anchor_click':
//           const anchor = document.createElement('a');
//           anchor.href = deepLink;
//           anchor.style.display = 'none';
//           document.body.appendChild(anchor);
//           anchor.click();
//           setTimeout(() => {
//             if (document.body.contains(anchor)) {
//               document.body.removeChild(anchor);
//             }
//           }, 1000);
//           break;
          
//         case 'form_submit':
//           const form = document.createElement('form');
//           form.method = 'GET';
//           form.action = deepLink;
//           form.target = '_blank';
//           form.style.display = 'none';
//           document.body.appendChild(form);
//           form.submit();
//           setTimeout(() => {
//             if (document.body.contains(form)) {
//               document.body.removeChild(form);
//             }
//           }, 1000);
//           break;
          
//         default:
//           window.location.href = deepLink;
//       }
//     } catch (error) {
//       console.log(`❌ Redirect method ${method} failed:`, error);
//     }
//   };

//   useEffect(() => {
//     if (!cleanerId) {
//       console.log('⚠️ No cleanerId found in URL');
//     }

//     // Start countdown
//     const countdownInterval = setInterval(() => {
//       setCountdown(prev => {
//         if (prev <= 1) {
//           clearInterval(countdownInterval);
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     // Try redirects in sequence with delays
//     const redirectSequence = [
//       { method: 'iframe', delay: 0 },
//       { method: 'anchor_click', delay: 100 },
//       { method: 'location_href', delay: 200 },
//       { method: 'form_submit', delay: 300 },
//       { method: 'location_replace', delay: 400 }
//     ];

//     redirectSequence.forEach(({ method, delay }) => {
//       setTimeout(() => {
//         if (!redirectAttemptedRef.current) {
//           attemptRedirect(method);
//         }
//       }, delay);
//     });

//     setRedirectAttempted(true);
//     redirectAttemptedRef.current = true;

//     // Show fallback after all methods have been tried
//     fallbackTimerRef.current = setTimeout(() => {
//       if (document.visibilityState === 'visible' && document.hasFocus()) {
//         console.log('📱 App not detected, showing fallback options');
//         setShowFallback(true);
//       }
//     }, 2000);

//     // Clean up
//     return () => {
//       clearInterval(countdownInterval);
//       if (fallbackTimerRef.current) {
//         clearTimeout(fallbackTimerRef.current);
//       }
//     };
//   }, [deepLink, cleanerId]);

//   // Listen for page visibility changes (app may have opened)
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.visibilityState === 'hidden') {
//         console.log('📱 Page hidden - app likely opened successfully');
//         if (fallbackTimerRef.current) {
//           clearTimeout(fallbackTimerRef.current);
//         }
//       }
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);
    
//     return () => {
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//     };
//   }, []);

//   const handleManualRedirect = () => {
//     console.log('👆 Manual redirect triggered');
//     attemptRedirect('location_href');
//   };

//   return (
//     <div style={styles.container}>
//       <h2>🎉 Onboarding Complete!</h2>
      
//       {cleanerId && (
//         <div style={styles.infoBox}>
//           <p><strong>Cleaner ID:</strong> {cleanerId}</p>
//         </div>
//       )}

//       <div style={styles.redirectSection}>
//         {countdown > 0 ? (
//           <>
//             <div style={styles.spinner}></div>
//             <p style={styles.redirectText}>
//               Redirecting to app in {countdown} second{countdown !== 1 ? 's' : ''}...
//             </p>
//           </>
//         ) : (
//           <p style={styles.redirectText}>
//             Redirecting to FreshSweeper app...
//           </p>
//         )}
        
//         <p style={styles.hint}>
//           If prompted, tap "Open" in the dialog that appears.
//         </p>
//       </div>
      
//       {showFallback && (
//         <div style={styles.fallback}>
//           <p>Having trouble opening the app?</p>
//           <div style={styles.buttonContainer}>
//             <button 
//               onClick={handleManualRedirect}
//               style={styles.primaryButton}
//             >
//               Tap to Open FreshSweeper App
//             </button>
            
//             <div style={styles.alternativeButtons}>
//               <a href={`/dashboard?cleanerId=${cleanerId}`} style={styles.secondaryButton}>
//                 Continue on Web
//               </a>
//               <a href="/" style={styles.tertiaryButton}>
//                 Go to Homepage
//               </a>
//             </div>
            
//             <p style={styles.troubleshooting}>
//               <strong>Troubleshooting:</strong>
//               <br />• Ensure the FreshSweeper app is installed
//               <br />• Check if your browser is blocking pop-ups
//               <br />• Try opening in Safari/Chrome instead
//             </p>
//           </div>
//         </div>
//       )}
      
//       {/* Hidden elements for redirect methods */}
//       <div style={{ display: 'none' }}>
//         <a id="hidden-anchor" href={deepLink}>Open App</a>
//         <iframe 
//           id="hidden-iframe" 
//           title="redirect"
//           src={deepLink} 
//           style={{ display: 'none' }}
//         />
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: '40px 20px',
//     textAlign: 'center',
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     maxWidth: '600px',
//     margin: '0 auto',
//     minHeight: '100vh',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   infoBox: {
//     background: '#f8f9fa',
//     padding: '15px',
//     borderRadius: '8px',
//     margin: '20px 0',
//     border: '1px solid #e9ecef',
//     width: '100%',
//   },
//   redirectSection: {
//     margin: '30px 0',
//     padding: '20px',
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 2px 12px rgba(36, 48, 63, 0.08)',
//     border: '1px solid #e0e0e0',
//     width: '100%',
//   },
//   spinner: {
//     width: '40px',
//     height: '40px',
//     border: '4px solid #f3f3f3',
//     borderTop: '4px solid #00BFFF',
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite',
//     margin: '0 auto 20px',
//   },
//   '@keyframes spin': {
//     '0%': { transform: 'rotate(0deg)' },
//     '100%': { transform: 'rotate(360deg)' },
//   },
//   redirectText: {
//     fontSize: '18px',
//     fontWeight: '600',
//     color: '#333',
//     marginBottom: '10px',
//   },
//   hint: {
//     fontSize: '14px',
//     color: '#666',
//     marginTop: '10px',
//   },
//   fallback: {
//     marginTop: '30px',
//     padding: '25px',
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 2px 12px rgba(36, 48, 63, 0.08)',
//     border: '2px solid #00BFFF',
//     width: '100%',
//   },
//   buttonContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '15px',
//     margin: '20px 0',
//   },
//   primaryButton: {
//     padding: '15px 24px',
//     backgroundColor: '#00BFFF',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     fontWeight: '600',
//     fontSize: '16px',
//     cursor: 'pointer',
//     transition: 'background-color 0.2s',
//   },
//   alternativeButtons: {
//     display: 'flex',
//     gap: '10px',
//     justifyContent: 'center',
//   },
//   secondaryButton: {
//     display: 'inline-block',
//     padding: '12px 20px',
//     backgroundColor: '#28a745',
//     color: 'white',
//     textDecoration: 'none',
//     borderRadius: '8px',
//     fontWeight: '600',
//     fontSize: '14px',
//     transition: 'background-color 0.2s',
//   },
//   tertiaryButton: {
//     display: 'inline-block',
//     padding: '12px 20px',
//     backgroundColor: '#6c757d',
//     color: 'white',
//     textDecoration: 'none',
//     borderRadius: '8px',
//     fontWeight: '600',
//     fontSize: '14px',
//     transition: 'background-color 0.2s',
//   },
//   troubleshooting: {
//     fontSize: '12px',
//     color: '#666',
//     textAlign: 'left',
//     marginTop: '15px',
//     padding: '10px',
//     background: '#f8f9fa',
//     borderRadius: '6px',
//     borderLeft: '3px solid #ffc107',
//   },
// };

// // Add CSS animation
// const styleSheet = document.createElement('style');
// styleSheet.textContent = `
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;
// document.head.appendChild(styleSheet);

// export default OnboardingComplete;